import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useCurrentUser } from '../../lib/hooks/useApi';
import ProfileCompletionModal from './ProfileCompletionModal';

interface ProfileCompletionWrapperProps {
  children: React.ReactNode;
}

export const ProfileCompletionWrapper: React.FC<ProfileCompletionWrapperProps> = ({ children }) => {
  const { user, isAuthenticated, isProfileComplete, logout } = useAuth();
  const { refetch } = useCurrentUser();
  const [showModal, setShowModal] = useState(false);

  // Show modal if user is authenticated but profile is not complete
  React.useEffect(() => {
    if (isAuthenticated && user && !isProfileComplete) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [isAuthenticated, user, isProfileComplete]);

  const handleProfileComplete = async () => {
    setShowModal(false);
    // Refetch user data to update profile completion status
    try {
      await refetch();
    } catch (error) {
      console.error('Failed to refetch user data:', error);
      // Fallback to page reload if refetch fails
      window.location.reload();
    }
  };

  const handleCloseModal = async () => {
    // Allow user to logout if they want to close the modal
    try {
      await logout();
      setShowModal(false);
    } catch (error) {
      console.error('Logout failed:', error);
      // Force redirect to login even if logout fails
      window.location.href = '/login';
    }
  };

  if (!isAuthenticated || !user) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      <ProfileCompletionModal
        isOpen={showModal}
        userEmail={user.email}
        onComplete={handleProfileComplete}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default ProfileCompletionWrapper;

